import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import CheackOutForm from './CheackOutForm';
import { Elements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe('pk_test_51K4VazLqEpkIafbhxY78CAju4W7myrBb1EUXOHaLUxJOfXiIOkgDdAz80kTGlvo21krfN9GaSpjIaK8wrNm5hK8600F6Zlahrc')
const Pay = () => {
    const { payId } = useParams()
    const [paymentData, setPaymentData] = useState({})
    useEffect(() => {
        fetch(`https://thawing-ridge-28572.herokuapp.com/mobile/${payId}`)
            .then(res => res.json())
            .then(data => setPaymentData(data))
    }, [payId])
    return (
        <div className='container'>
            <div className="row">
                <div className="col-md-12">
                    <div
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="1500"
                    className=' text-center'>
                        <h4>Please Pay For ${paymentData.price} for {paymentData.phonename} </h4>
                        <div className="text-start">
                            <h5>Your Name: <em className='fs-5 text-primary'>{paymentData.name} </em> </h5>
                            <h6> Your email: {paymentData.email} </h6>
                            <h5> Mobile Name:  <em className='fs-5 text-primary'>{paymentData.phonename} </em> </h5>
                            <h4>Mobile Price : <em className='fs-5 text-primary'> ${paymentData.price}</em> </h4>
                        </div>
                    </div>
                    {paymentData?.price && <Elements stripe={stripePromise}>
                        <CheackOutForm paymentData={paymentData} />
                    </Elements>}
                </div>
                {/* <div className="col-md-5">
                    <div>
                        <p>You Can Check Its Stipe Js Payment Check Integraiton</p>
                        <h6> 2223003122003222 </h6>
                        <h6> 5200828282828210 </h6>
                        <h6> 378282246310005 </h6>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Pay;